import { Header } from "./Header";

export const Overlay = ({ referrer }) => (
  <div className="left-box-overlay" id="main-map-overlay">
    <Header referrer={referrer} />
    <h2 className="chart-title" style={{ fontWeight: "900" }}>
      How your NYC neighbors voted in 2024
    </h2>

    <p className="chart-dek ml-0" style={{ lineHeight: "22px" }}>
      New York City had the lowest Democratic vote share in decades, and former
      President Donald Trump made{" "}
      <a
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#0c71fa" }}
        href="https://www.thecity.nyc/2024/11/05/election-day-voters-sheepshead-bay-chelsea/"
      >
        significant gains
      </a>{" "}
      in the{" "}
      <a
        style={{ color: "#0c71fa" }}
        href="https://projects.thecity.nyc/the-city-election-coverage-2024/"
        target="_blank"
        rel="noopener noreferrer"
      >
        2024 presidential election
      </a>
      . Here’s how the vote broke down in each election district.
    </p>

    <div style={{ marginBottom: "5px" }}>
      <a
        className="chart-dek"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#ebf87e",
          border: "1.5px solid #ebf87e",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingLeft: "5px",
          paddingRight: "5px",
          textDecoration: "none",
          borderRadius: "15px",
          fontSize: "14px",
        }}
        href="https://projects.thecity.nyc/trump-shift-new-york-change-election-vote/"
      >
        Neighborhood Shift Toward Trump Map
      </a>
    </div>

    <div
      className="chart-dek"
      style={{
        marginLeft: "0px",
        color: "white",
        fontSize: "12px",
        fontStyle: "italic",
        lineHeight: "15px",
      }}
    >
      *Mapped with unofficial election results. Design & Development by Sujin
      Shin, Data by Haidee Chu
    </div>
    <div className="map-geocoder-placeholder" />
  </div>
);
